import { formatOrdinal, formatPts } from './numbers.helpers'

const timeBasedBonusRecord = (t, key, value, isCurrent) => {
  return {
    label:
      key === 'last'
        ? t('home.last-wallet-to-deposit')
        : t('home.wallet-to-deposit', { position: formatOrdinal(key) }),
    value: formatPts(value),
    isCurrent
  }
}

const amountBasedBonusRecord = (t, key, value, customKey, isCurrent) => {
  return {
    label:
      key === 'max'
        ? t('home.wallet-to-deposit-largest-amount')
        : t('home.first-wallet-to-deposit', { value: customKey || key }),
    value: formatPts(value),
    isCurrent
  }
}

const referralBasedBonusRecord = (t, key, value, customKey, isCurrent) => {
  return {
    label:
      key === 'most'
        ? t('home.most-referred-wallets')
        : t('home.first-to-refer', { value: customKey || key }),
    value: formatPts(value),
    isCurrent
  }
}

const buildNotifications = (
  {
    timeBasedPoints,
    timeBasedPosition,
    amountBasedPoints,
    amountBasedPosition,
    referralBasedPoints,
    referralBasedPosition
  },
  t
) => {
  return [
    ...(timeBasedPoints > 0
      ? [timeBasedBonusRecord(t, timeBasedPosition, timeBasedPoints)]
      : []),
    ...(amountBasedPoints > 0
      ? [amountBasedBonusRecord(t, amountBasedPosition, amountBasedPoints)]
      : []),
    ...(referralBasedPoints > 0
      ? [
          referralBasedBonusRecord(
            t,
            referralBasedPosition,
            referralBasedPoints
          )
        ]
      : [])
  ]
}

export {
  timeBasedBonusRecord,
  amountBasedBonusRecord,
  referralBasedBonusRecord,
  buildNotifications
}
